import {
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  CopyOutlined,
  NotificationOutlined,
  EditOutlined
} from '@ant-design/icons'
import { Button, Form, Input, Space, Tooltip, Modal } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import { addressSearch } from '../../services/postservice'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import {
  addProject,
  deleteProject,
  detailProject,
  getAll,
  houseViewList,
  notificationList,
  updateProject
} from '../../services/projectRecommendservice'
import { ACTION_MODE, PAGE_SIZE_OPTIONS } from '../../configData'
import dayjs from 'dayjs'
import {
  convertPriceToNumber,
  formatCurrencyLabel,
  formatCurrencyUnit,
  hasPermission,
  removeUndefinedValues
} from '../../config-func'
import FormAddExcel from './FormAddExcel'
import ModalNotification from './ModalNotification'
import ModalListHouse from './ModalListHouse'
import { debounce } from 'lodash'
import Loading from '../Loading'
const ProjectRecommendManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [isModalImportOpen, setIsModalImportOpen] = useState(false)
  const [project, setProject] = useState('')
  const [dataHouseView, setDataHouseView] = useState([])
  const [isLoadingHouse, setIsLoadingHouse] = useState(false)
  // const [overviewInfo, setOverviewInfo] = useState()
  const [ownerInfo, setOwnerInfo] = useState()
  const [policyInfo, setPolicyInfo] = useState()
  const [detailInfo, setDetailInfo] = useState()
  const [dataEditor, setDataEditor] = useState({
    overview: '',
    policy: '',
    detail_info: ''
  })
  const [isText, setIsText] = useState(false)

  // get arr select
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])
  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10
  })

  const handleSearch = debounce(() => {
    if (filters.pageNo === 1) {
      fetchData(filters)
    } else {
      setFilters((prev) => ({ ...prev, pageNo: 1 }))
    }
  }, 500)

  async function fetchData(values) {
    setLoading(true)
    let _dataSource = []
    let _total = 0

    const body = removeUndefinedValues(values || {})
    try {
      const response = await getAll({ ...body, pageSize: filters.pageSize })

      if (response?.message == 'Lấy danh sách thành công !') {
        _total = response?.data?.total
        _dataSource = response?.data?.list
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData(filters)
  }, [filters.pageNo, filters.pageSize])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.pageNo - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Order',
      dataIndex: 'display_order',
      key: 'display_order',
      width: 100,
      align: 'center'
    },
    {
      title: 'Tên dự án',
      dataIndex: 'name',
      key: 'name',
      width: 200
    },
    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city',
      key: 'city',
      width: 150,
      render: (_, record) => {
        return <span>{record?.city?.name}</span>
      }
    },
    {
      title: 'Quận/huyện',
      dataIndex: 'district',
      key: 'district',
      width: 150,
      render: (_, record) => {
        return <span>{record?.district?.name}</span>
      }
    },
    {
      title: 'Phường xã',
      dataIndex: 'town',
      key: 'town',
      width: 150,
      render: (_, record) => {
        return <span>{record?.town?.name}</span>
      }
    },
    {
      title: 'Đường phố',
      dataIndex: 'address',
      key: 'address',
      width: 200
      // render: (_, record) => {
      //   return <span>{record?.district?.name}</span>
      // }
    },
    {
      title: 'Chủ đầu tư',
      dataIndex: 'owner_name',
      key: 'owner_name',
      width: 150
    },

    {
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      width: 150,
      render: (_, record) => {
        return (
          <span>
            {formatCurrencyLabel(record?.price_min)} -{' '}
            {formatCurrencyLabel(record?.price_max)}
          </span>
        )
      }
      // render: (_, record) => (
      //   <span>
      //     {listProject.find((n) => n.id === record.project_id)?.project_name ||
      //       ''}
      //   </span>
      // )
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'post_recommend_files',
      key: 'post_recommend_files',
      render: (post_recommend_files) => {
        return (
          <div style={{ display: 'flex', gap: '5px', height: '50px' }}>
            {post_recommend_files?.map((file) => {
              if (file.type === 2) return null
              return (
                <img
                  key={file.id}
                  src={file.link}
                  alt="Post"
                  width={50}
                  height={50}
                  style={{ objectFit: 'cover', cursor: 'pointer' }}
                  onClick={() => {
                    setPreviewImage(file.link)
                    setPreviewVisible(true)
                    setPreviewTitle(false)
                  }}
                />
              )
            })}
          </div>
        )
      }
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 180,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P44.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)
                    getDetailProject(record.id)
                  }}
                />
              </Tooltip>
            )}
            {hasPermission('P44.5', permissions) && (
              <Tooltip title="Danh sách nhận thông báo">
                <Button
                  style={{ width: 32 }}
                  icon={<NotificationOutlined />}
                  onClick={() => {
                    setIsModalNotificationOpen(true)
                    setProject(record)
                    // getListNotification(record.id)
                  }}
                />
              </Tooltip>
            )}
            {hasPermission('P44.6', permissions) && (
              <Tooltip title="Danh sách đăng ký xem nhà">
                <Button
                  style={{ width: 32 }}
                  icon={<CopyOutlined />}
                  onClick={() => {
                    setIsModalHouseViewOpen(true)
                    setProject(record)
                    getListHouseView(record.id)
                  }}
                />
              </Tooltip>
            )}
            {hasPermission('P44.3', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá dự án mở bán
                          <b> {record.name}</b> không?
                        </div>
                      ),
                      onOk: () => handleDeleteProject(record.id)
                    })
                  }
                />
              </Tooltip>
            )}
          </Space>
        )
      }
    }
  ]
  const [fileLocation, setFileLocation] = useState([])
  const [fileList, setFileList] = useState([])
  const [fileLogo, setFileLogo] = useState([])
  const [fileList360, setFileList360] = useState([])
  const [fileListDesign, setFileListDesign] = useState([])
  const [fileListSample, setFileListSample] = useState([])
  const [isModalNotificationOpen, setIsModalNotificationOpen] = useState(false)
  const [isModalHouseViewOpen, setIsModalHouseViewOpen] = useState(false)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState(false)
  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    const values = await form.validateFields()

    const normalizeData = (data) => {
      if (typeof data === 'string') {
        return [{ link: data, type: 2 }] // Nếu là string, đưa vào array
      } else if (Array.isArray(data)) {
        return data.map((item) => ({
          link: item.link,
          type: 2
        }))
      }
      return [] // Trả về mảng rỗng nếu không hợp lệ
    }
    // const fileVideo = values?.urls_video
    //   ? [{ type: '2', link: values?.urls_video }]
    //   : ''

    let img_360 = []

    if (isText) {
      img_360 = values.urls_image_360.map((item) => ({
        type: 3,
        link: item.url
      }))
    } else {
      img_360 = values.urls_image_360?.fileList?.map((item) => ({
        type: 3,
        link: item.response?.[0]?.link
      }))
    }

    const fileVideo = normalizeData(values?.urls_video)
    const file360 = img_360

    const file = [
      ...fileLocation,
      ...fileList,
      ...fileListDesign,
      ...fileListSample
    ]
    // const extractedResponses = file
    //   .map((item) => item.response)
    //   .flat()
    //   .filter(Boolean) // Loại bỏ null và undefined

    const formattedData = file?.map((item) => ({
      link: item.response?.[0]?.link || item.url, // Lấy link từ response hoặc url
      type: Number(item.response?.[0]?.type) || item.tp // Lấy type từ response hoặc tp
    }))

    const projectLogoLink =
      fileLogo?.[0]?.response?.[0]?.link || fileLogo?.[0]?.url || ''

    // Kiểm tra nếu cả hai giá trị đều tồn tại
    const {
      id,
      urls_video,
      urls_image_360,
      overview,
      owner_description,
      ...data
    } = values

    let body = {}
    if (values.utility?.length > 0) {
      body = {
        ...data,
        files:
          urls_video?.length > 0 && file360?.length > 0
            ? [...formattedData, ...fileVideo, ...file360]
            : urls_video?.length > 0
            ? [...formattedData, ...fileVideo]
            : file360?.length > 0
            ? [...formattedData, ...file360]
            : formattedData,
        document: data.document || [],
        owner_description: dataEditor.owner_description || '<p>   </p>',
        overview: dataEditor.overview || '<p>   </p>',
        policy: dataEditor.policy || '<p>   </p>',
        detail_info: dataEditor.detail_info || '<p>   </p>',
        contact_phone: data.contact_phone || '',
        open_sale_status: data.open_sale_status ? data.open_sale_status : false,
        start_time: values.start_time
          ? dayjs(values.start_time).format('DD/MM/YYYY')
          : '',
        handover_time: values.handover_time
          ? dayjs(values.handover_time).format('DD/MM/YYYY')
          : '',
        price_max: values.price_max
          ? convertPriceToNumber(values.price_max?.toString())
          : 0,
        price_min: values.price_min
          ? convertPriceToNumber(values.price_min?.toString())
          : 0,
        building_density: values.building_density
          ? convertPriceToNumber(
              values.building_density?.toString()
            )?.toString()
          : 0,
        utility: values.utility || '',
        type_of_housing: values.type_of_housing
          ? values.type_of_housing.join(',')
          : ''
      }
    } else {
      body = {
        ...data,
        files:
          urls_video?.length > 0 && file360?.length > 0
            ? [...formattedData, ...fileVideo, ...file360]
            : urls_video?.length > 0
            ? [...formattedData, ...fileVideo]
            : file360?.length > 0
            ? [...formattedData, ...file360]
            : formattedData,
        document: data.document || [],
        owner_description: dataEditor.owner_description || '<p>   </p>',
        overview: dataEditor.overview || '<p>   </p>',
        policy: dataEditor.policy || '<p>   </p>',
        detail_info: dataEditor.detail_info || '<p>   </p>',
        contact_phone: data.contact_phone || '',
        open_sale_status: data.open_sale_status ? data.open_sale_status : false,
        start_time: values.start_time
          ? dayjs(values.start_time).format('DD/MM/YYYY')
          : '',
        handover_time: values.handover_time
          ? dayjs(values.handover_time).format('DD/MM/YYYY')
          : '',
        price_max: values.price_max
          ? convertPriceToNumber(values.price_max?.toString())
          : 0,
        price_min: values.price_min
          ? convertPriceToNumber(values.price_min?.toString())
          : 0,
        building_density: values.building_density
          ? convertPriceToNumber(
              values.building_density?.toString()
            )?.toString()
          : 0,
        type_of_housing: values.type_of_housing
          ? values.type_of_housing.join(',')
          : ''
      }
    }

    if (projectLogoLink) {
      body.project_logo = projectLogoLink
    }

    if (!body.price_min || body.price_min === 0) {
      delete body.price_min
    }
    if (!body.price_max || body.price_max === 0) {
      delete body.price_max
    }
    if (!body.building_density || body.building_density === 0) {
      delete body.building_density
    }

    try {
      const res =
        mode == ACTION_MODE.ADD
          ? await addProject(body)
          : await updateProject(body, id)

      if (data?.name) {
        form.resetFields()
        setIsModalOpen(false)
        fetchData({
          pageNo: 1,
          pageSize: 10
        })
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Tạo mới dự án thành công !'
            : 'Cập nhật dự án thành công !'
        )
        // setOverviewInfo('')
        setOwnerInfo('')
        setPolicyInfo('')
        setDetailInfo('')
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Xóa project
  const handleDeleteProject = async (ids) => {
    setLoading(true)
    const body = {
      ids: [ids]
    }
    try {
      const res = await deleteProject(body || [])
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Chi tiết dự án
  const getDetailProject = async (id) => {
    setLoading(true)
    try {
      const res = await detailProject(id) // Assuming roleSearch is an API function
      if (res && res.data) {
        const values = res.data
        // form.setFieldsValue({
        //   ...values,
        //   start_time: values.start_time
        //   ? dayjs(values.start_time, 'DD/MM/YYYY')
        //   : '',
        // handover_time: values.handover_time
        //   ? dayjs(values.handover_time, 'DD/MM/YYYY')
        //   : ''
        // })
        const groupedImages = values.post_recommend_files.reduce(
          (acc, item) => {
            if (!acc[item.type]) acc[item.type] = []
            acc[item.type].push({
              uid: item.id.toString(),
              name: `Image-${item.id}`,
              status: 'done',
              url: item.link,
              tp: Number(item.type)
              // type: item.type
            })
            return acc
          },
          {}
        )

        // Lấy danh sách file cho type 6
        const fileList1 = groupedImages[1] || []
        const imgType2 = groupedImages[2] || []
        const fileList3 = groupedImages[3] || []
        const fileList4 = groupedImages[4] || []
        const fileList5 = groupedImages[5] || []
        const fileList6 = groupedImages[6] || []

        setFileList(fileList1)
        // setFileList(imgType2) //Video
        setFileList360(fileList3)
        setFileListDesign(fileList4)
        setFileListSample(fileList5)
        setFileLocation(fileList6)
        setFileLogo(
          values?.project_logo
            ? [
                {
                  uid: 'project_logo',
                  name: 'Logo chủ đầu tư',
                  status: 'done',
                  url: values.project_logo
                }
              ]
            : []
        )
        // setOverviewInfo(values.overview)
        setOwnerInfo(values.owner_description)
        setPolicyInfo(values.policy)
        setDetailInfo(values.detail_info)
        setDataEditor({
          overview: values.overview,
          policy: values.policy,
          detail_info: values.detail_info,
          owner_description: values.owner_description
        })
        //  const utilityArray = values.utility ? JSON.parse(values.utility) : []
        form.setFieldsValue({ urls_image_360: fileList3 })
        setIsText(fileList3?.length > 0 ? true : false)

        const formatted = values.type_of_housing
          .replace(/"/g, '')
          .replace(/-/g, ',')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean)

        form.setFieldsValue({
          ...values,
          type_of_housing: formatted,
          urls_video: imgType2?.[0]?.url || '',
          start_time: values.start_time
            ? dayjs(values.start_time, 'DD/MM/YYYY')
            : '',
          handover_time: values.handover_time
            ? dayjs(values.handover_time, 'DD/MM/YYYY')
            : ''
        })

        getListDistricts(values.city_code)
        getListTowns(values.district_code)
        setIsModalOpen(true)
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  // Danh sách thành phố
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  // Danh sách quận huyện
  const getListDistricts = async (i) => {
    const params = {
      parent_code: i
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  // Danh sách phường xã
  const getListTowns = async (code) => {
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    getListCities()
  }, [])

  const onChangeCity = (e) => {
    setDistricts([])
    setTowns([])
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })
  }
  const onChangeDistrict = (e) => {
    setTowns([])
    const code = districts.filter((item) => item.code == e)?.[0]?.code
    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  // danh sách đăng ký xem nhà
  const getListHouseView = async (id) => {
    setIsLoadingHouse(true)
    try {
      const res = await houseViewList(id) // Assuming roleSearch is an API function
      if (res?.data?.list) {
        setDataHouseView(res?.data?.list)
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setIsLoadingHouse(false)
    }
  }

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          cities={cities}
          districts={districts}
          towns={towns}
          onChangeCity={onChangeCity}
          setDistricts={setDistricts}
          onChangeDistrict={onChangeDistrict}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý hàng dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {hasPermission('P44.4', permissions) && (
              <Button
                type="primary"
                key="primary"
                onClick={() => {
                  setIsModalImportOpen(true)
                }}
              >
                <PlusOutlined /> Import Excel
              </Button>
            )}
            {hasPermission('P44.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.pageNo,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                pageNo: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, pageNo: page }))
            },
            locale: { items_per_page: 'bản ghi / trang' },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa dự án mở bán'
            : 'Thêm mới dự án mở bán'
        }
        width={1200}
        visible={isModalOpen}
        centered
        onCancel={() => {
          // setOverviewInfo('')
          setOwnerInfo('')
          setPolicyInfo('')
          setDetailInfo('')
          setIsModalOpen(false)
          form.resetFields()
          setFileList([])
          setFileLogo([])
          setFileList360([])
          setFileListDesign([])
          setFileListSample([])
          setFileLocation([])
          setDataEditor({
            overview: '',
            policy: '',
            detail_info: ''
          })
          setIsText(false)
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost
          form={form}
          handleSearch={handleSearch}
          cities={cities}
          districts={districts}
          towns={towns}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          fileList={fileList}
          fileLogo={fileLogo}
          fileLocation={fileLocation}
          fileList360={fileList360}
          fileListDesign={fileListDesign}
          fileListSample={fileListSample}
          setFileLocation={setFileLocation}
          setFileList={setFileList}
          setFileLogo={setFileLogo}
          setFileList360={setFileList360}
          setFileListDesign={setFileListDesign}
          setFileListSample={setFileListSample}
          // overviewInfo={overviewInfo}
          policyInfo={policyInfo}
          detailInfo={detailInfo}
          // setOverviewInfo={setOverviewInfo}
          ownerInfo={ownerInfo}
          setOwnerInfo={setOwnerInfo}
          setPolicyInfo={setPolicyInfo}
          setDetailInfo={setDetailInfo}
          setDataEditor={setDataEditor}
          setIsText={setIsText}
          isText={isText}
        />
      </ModalCustom>
      <ModalNotification
        isModalOpen={isModalNotificationOpen}
        setIsModalOpen={setIsModalNotificationOpen}
        onClose={() => setIsModalNotificationOpen(false)}
        data={project}
      />

      <ModalListHouse
        loading={isLoadingHouse}
        isModalOpen={isModalHouseViewOpen}
        setIsModalOpen={setIsModalHouseViewOpen}
        onClose={() => setIsModalHouseViewOpen(false)}
        data={dataHouseView}
        project={project}
      />
      <FormAddExcel
        isModalOpen={isModalImportOpen}
        setIsModalOpen={setIsModalImportOpen}
        fetchApiList={fetchData}
      />
      <ModalConfirm />
      <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="preview" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </div>
  )
}

export default ProjectRecommendManagement
